<template>
  <div class="mx-auto max-w-xl px-2">
    <h1 v-html="$t('pages.about.heading')" />
    <div class="debug">{{ apiBase }}</div>
    <div class="debug">{{ $dayjs().tz().format('YYYY-MM-DD HH:mm dddd') }}</div>
  </div>
</template>

<script setup>
const apiBase = useEnv('apiBase')
const message = "hello Mr About Page"
await useDelay(500)
console.log(message)
</script>
